import React from 'react';
import './privateInvite.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button } from 'devextreme-react';
import { ResponseError, UsersApi } from '../../data';
import { apiConfiguration } from '../../apiConfig';
import { jwtDecode, JwtPayload } from 'jwt-decode';
import { showError } from '../../utils/errorHandling';
import { SingleCard } from '../../layouts';
import InvitoShowToken from '../../components/InvitoShowToken/InvitoShowToken';
import { useMsal } from '@azure/msal-react';

export default function PrivateInvite() {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState<boolean>(false);

  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get('token');

  const handleAccetta = async (tenantId: string) => {
    setLoading(true);
    try {
      var api = new UsersApi(apiConfiguration);
      if (token) {
        await api.acceptUserInvite({ tenantId: tenantId, acceptUserInviteDTO: { token: token } });

        navigate('/home', { state: { tenantId: tenantId } });
      }
    }
    catch (e:any) {

     showError(e);
    }
    finally{
      setLoading(false);
    }
  };

  try {
    const decoded: any = jwtDecode<JwtPayload>(String(token));
console.log(decoded);
    return (
      <SingleCard title="Invito a partecipare a Hyper-GES" >
        <div className='invite-form'>
          <PresentationRender />  
          
          <InvitoShowToken jwtPayload={decoded} /> 

          <div className='center-button'>
            <Button
              text="Accetta invito"
              type='default'
              onClick={() => handleAccetta(decoded.tenant_id)}
              height={50} 
              disabled={loading}
              />
          </div>
        </div>
      </SingleCard>
    );
  }
  catch {
    return (
      <React.Fragment>
        Link di invito non valido.
      </React.Fragment>
    )
  }
}

function PresentationRender() {
  const { instance } = useMsal();
  try {
    const account = instance.getActiveAccount();

   // console.log(account);
  return (
    <React.Fragment>
        <h4>Utente corrente</h4>
        <div><b>{account?.name}</b></div>
        <div>Email: <b>{account?.username}</b></div>
    </React.Fragment>
  );
}
catch (e) {
  console.error(e);
  return (
    <React.Fragment>
    
    </React.Fragment>
  );
}
}

